import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import CustomExpandableTable from "../../../../components/table/CustomExpandableTable";
import NotInformation from "../../../../components/NotInformation";
import React from "react";
import {HistoryTabApp} from "../Funtionality/HistoryTabApp";
import RenderExpandedRow from "./RenderExpandedRow";
import {VIEW_TYPE} from "../../../../enums/ViewType";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const HistoryTab = ({
                        supplierId,
                        setShowDeleteModal,
                        setShowDetails,
                        setRow,
                        modified,
                        setModified
                     }) => {


    const {
        searchElement,
        setSearchElement,
        setBodyForExport,
        setSearchResults,
        option,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        searchResults,
        selectedList,
        searchId,
        columns,
        handleCheckboxChange,
        pagination,
        handleDeleteAll,
        renderOptionsMenu,
        handleRowExpand,
        t
    } = HistoryTabApp({
        supplierId,
        setShowDeleteModal,
        setShowDetails,
        setRow,
        modified,
        setModified
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={supplierId}
                viewType={VIEW_TYPE.GRID.viewType}
            />
            {searchResults?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={searchResults?.content || []}
                        renderExpandedRow={RenderExpandedRow}
                        renderOptionsMenu={renderOptionsMenu}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        checkbox={false}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation className={"mt-4"} card={true} text={t('no_information')}/>
            )}
        </>
    )
}

export default HistoryTab
